import "../button/size.mjs";
import { typographyRecipe as o } from "../typography/index.mjs";
import "../input/base.mjs";
const i = o.size["sans-serif"], t = {
  glassy: {
    paddingTop: "spacing-1.5",
    paddingBottom: "spacing-1.5",
    paddingLeft: "spacing-3",
    paddingRight: "spacing-3",
    backgroundColor: "alpha-white-50",
    borderColor: "alpha-white-30",
    borderWidth: 1,
    borderRadius: "border-20",
    color: "text-white",
    fontFamily: "sans-serif",
    fontWeight: "medium",
    ...i.md,
    height: 32,
    gap: "spacing-2"
  },
  flat: {
    paddingTop: "spacing-1.5",
    paddingBottom: "spacing-1.5",
    paddingLeft: "spacing-2",
    paddingRight: "spacing-2",
    backgroundColor: "#f9f9f9",
    borderColor: "#eeeff0",
    borderWidth: 1,
    borderRadius: "radius-2",
    backdropFilter: "blur(2px)",
    color: "#29323f",
    fontFamily: "sans-serif",
    fontWeight: "medium",
    ...i.md,
    height: 32,
    gap: "spacing-2"
  }
}, e = 16;
export {
  t as PropertyChipVariants,
  e as propertyChipIconSize
};
